import { define } from '../../define.js';
import { StickyBar } from './sticky-bar.js';
export * from './sticky-bar.js';
define('sticky-bar', StickyBar);
